module.exports = __webpack_public_path__ + "static/img/tab-ten-active.2a842fb4.png";